module.exports = "<a mat-fab mat-button color=\"primary\" [routerLink]=\"[url]\">\r\n  <mat-icon>add</mat-icon>\r\n</a>\r\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms/src/add-button/add-button.component.html
// module id = ./libs/atenea-cms/src/add-button/add-button.component.html
// module chunks = main